import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { FournisseurAuth } from './auth/contexte';
import { EVENEMENT_MISE_A_JOUR, FournisseurFile } from './horsligne/contexte';
import './styles.css';
import { apparenceMemorisee, appliquerApparence } from './theme';

// Dernier style appliqué sur ce téléphone, avant tout rendu : pas d'éclair clair avant le sombre.
appliquerApparence(apparenceMemorisee());

const racine = document.getElementById('racine');
if (!racine) throw new Error('Élément #racine introuvable');

// Nouvelle version du service worker : un bandeau propose de recharger, jamais
// de rechargement forcé (le brouillon est sur le téléphone, mais une saisie en
// cours de frappe ne s'interrompt pas). La première installation ne compte pas.
if ('serviceWorker' in navigator) {
  const avaitUnControleur = navigator.serviceWorker.controller !== null;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (avaitUnControleur) window.dispatchEvent(new Event(EVENEMENT_MISE_A_JOUR));
  });
}

createRoot(racine).render(
  <StrictMode>
    <BrowserRouter>
      {/* La file vit sous l'authentification, toujours montée : l'écran de connexion compte les saisies. */}
      <FournisseurAuth enfants={<FournisseurFile enfants={<App />} />} />
    </BrowserRouter>
  </StrictMode>,
);
